<template>
  <footer>
    <div class="container fluid bottom-0">
      <div class="row text-center">
        <div class="col-12">versión : {{ applicationVersion }}</div>
      </div>
    </div>
  </footer>
</template>

<script>
import { version } from "../../../package.json";

export default {
  data() {
    return {
      applicationVersion: version,
    };
  },
};
</script>
